import { useLocation } from 'react-router-dom';

import SupportChat from '@/components/SupportChat';
import { useLanguage } from '@/components/LanguageContext';
import LandingFooterV3 from '@/components/landing/v3/LandingFooterV3';
import LandingNavV3 from '@/components/landing/v3/LandingNavV3';
import useSeoHead from '@/hooks/useSeoHead';
import { paginaDeLaRuta } from '@/lib/rutasPublicas';

import '@/pages/landingV3.css';

/**
 * LandingShellV3 — el marco que comparten las diez páginas públicas del V3:
 * raíz scopeada, cabecera, chat de soporte y pie.
 *
 * Existe para que una página V3 sea solo su contenido. En la V2 cada página
 * repite `<div className="landing-v2">`, `<SupportChat />`, `<LandingNav />` y
 * `<LandingFooter />` a mano, y son cinco páginas; aquí son diez y la copia se
 * habría desincronizado a la tercera.
 *
 * El `padding-top` de la primera sección lo pone `.v3-top` (ver
 * `landingV3.css`), porque la cabecera es `fixed` y su alto no lo puede saber
 * el flujo del documento. Si se le añade o quita algo a la cabecera, hay que
 * ajustar ahí `--v3-header` o queda un hueco muerto (o texto tapado).
 *
 * ── EL `<head>` SE RESUELVE AQUÍ, Y DESDE LA URL ────────────────────────────
 *
 * El marco sabe qué página es porque se lo dice `paginaDeLaRuta()`, no un prop.
 * Podría pasarse desde cada página, pero entonces una podría declarar que es
 * otra: el `canonical` apuntaría a una URL distinta de la que el visitante
 * tiene en la barra, que es de los errores de SEO más caros y de los que no dan
 * ningún síntoma. Derivándolo de la ruta, no se puede escribir mal.
 */
export default function LandingShellV3({ children }) {
  const { pathname } = useLocation();
  const { language } = useLanguage();
  useSeoHead(paginaDeLaRuta(pathname), language);

  return (
    <div className="landing-v3 min-h-screen w-full">
      <SupportChat />
      <LandingNavV3 />
      <main className="v3-top">{children}</main>
      <LandingFooterV3 />
    </div>
  );
}
